import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CommonModal from "../Common/Modals/CommonModal";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
  content: {
    // width: "90vw",
    // maxHeight: "70vh",
    // overflow: "auto",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxHeight: "50vh",
    },
  },
  adImage: {
    height: "60vh",
    objectFit: "contain",
    [theme.breakpoints.down("md")]: {
      //   maxHeight: "50vh",
      width: "100%",
      height: "auto",
    },
  },
}));

const AdvertiseModal = ({ data, open, onClose }) => {
  const classes = useStyles();

  return (
    <CommonModal open={open} title={data.title} onClose={() => onClose()}>
      <div className={classes.content}>
        <img src={data.imageSrc} className={classes.adImage} />
      </div>
    </CommonModal>
  );
};
export default AdvertiseModal;
